import { extend, configure } from "vee-validate";

import {
  required,
  email,
  numeric,
  length,
  min_value,
} from "vee-validate/dist/rules";
import { i18n } from "./i18n";

extend("required", required);
extend("email", email);
extend("numeric", numeric);
extend("length", length);
extend("min_value", min_value);
extend("confirmed", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
});

configure({
  // this will be used to generate messages.
  defaultMessage: (_, values) => i18n.t(`validations.${values._rule_}`, values),
});
